import { api } from './client';

export interface AddEmailResponse {
    success: boolean;
    conflict?: boolean;
    message?: string;
}

export interface LinkTelegramResponse {
    success: boolean;
    deepLink: string;
    token: string;
    expiresInMinutes: number;
}

export interface MergeResponse {
    success: boolean;
    message?: string;
    mergedUser?: {
        userId: string;
        email?: string;
        telegramId?: number;
        tier: string;
        emailVerified: boolean;
    };
    migratedSubscriptions?: number;
    migratedPayments?: number;
    error?: string;
}

export async function addEmailToAccount(email: string, password: string): Promise<AddEmailResponse> {
    const response = await api.put('/user/profile/email', { email, password });
    return response.data;
}

export async function generateTelegramLink(): Promise<LinkTelegramResponse> {
    const response = await api.post('/user/link-telegram');
    return response.data;
}

export async function mergeAccounts(params: {
    sourceType: 'email' | 'telegram';
    sourceEmail?: string;
    sourcePassword?: string;
    telegramLinkToken?: string;
}): Promise<MergeResponse> {
    const response = await api.post('/user/merge', params);
    return response.data;
}
